import { SVGProps } from 'react';

const RemoveFormatting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 7V4h16v3M5 20h6m2-16L8 20m7-5 5 5m0-5-5 5"
    />
  </svg>
);
export default RemoveFormatting;
